export enum BONUSX_SUBSCRIPTION_FREQUENCIES {
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}
